import { inject } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * Inicializador de auth no boot: dispara a restauração da sessão interna (via refresh).
 *
 * Isto NÃO garante que a sessão esteja restaurada antes da navegação inicial: o Angular
 * dispara todos os initializers em paralelo e só depois aguarda o Promise.all, enquanto o
 * router já inicia a navegação — ou seja, os guards correm com o refresh. Quem fecha essa
 * corrida é o próprio AuthGuard, que aguarda a mesma restauração (memoizada em initAuth).
 *
 * O retorno do login pelo Keycloak (?code&state) NÃO é tratado aqui — fica a cargo
 * do keycloakCallbackGuard (guard de rota assíncrono), que o router aguarda e que
 * por isso não corre com a navegação inicial bloqueante.
 */
export function initializeAuth(): () => Promise<void> {
    const authService = inject(AuthService);
    return () => authService.initAuth();
}
